<template>
  <div
    v-if="displayName"
    class="candidate-watermark"
    data-exam-integrity-ignore
    aria-hidden="true"
  >
    <span
      v-for="index in 24"
      :key="index"
      class="candidate-watermark__name"
    >
      <span
        v-for="(line, lineIndex) in displayLines"
        :key="lineIndex"
        class="candidate-watermark__line"
      >
        {{ line }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: "CandidateWatermark",
  props: {
    watermarkText: {
      type: String,
      default: "",
    },
  },
  computed: {
    displayName() {
      return (this.watermarkText || "").trim();
    },
    displayLines() {
      const atIndex = this.displayName.indexOf("@");
      if (atIndex <= 0) {
        return [this.displayName];
      }
      return [
        this.displayName.slice(0, atIndex),
        this.displayName.slice(atIndex),
      ];
    },
  },
};
</script>

<style scoped>
.candidate-watermark {
  position: absolute;
  z-index: 2;
  inset: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: minmax(92px, 1fr);
  gap: 16px 24px;
  padding: 26px 10px;
  box-sizing: border-box;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
}

.candidate-watermark__name {
  align-self: center;
  justify-self: center;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  max-width: none;
  color: rgba(21, 57, 126, 0.14);
  font-family: Montserrat-SemiBold, sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.015em;
  line-height: 1.15;
  text-align: center;
  transform: rotate(-24deg);
}

.candidate-watermark__line {
  display: block;
  white-space: nowrap;
}
</style>
